import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { BusinessSummary } from './BusinessSummary';
import { Ledger } from './Ledger';
import { Outstanding } from './Outstanding';

export const Business = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [dealer, setDealer] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [page, setPage] = useState<string>("ledger");

    useEffect(() => {
        if(user.profile) {
            setDealer(user.profile.profile);
        }
      }, [user]);

    return (
        <div className="page-business">
            {(page === "business_summary") &&
                <BusinessSummary />
            }
            {(page === "ledger") &&
                <Ledger />
            }
            {(page === "outstandings") &&
                <Outstanding />
            }
        </div>
    );
}